interface HorizontalScrollBox {
	scrollLeft: number;
	scrollWidth: number;
	clientWidth: number;
}

const getHorizontalScrollMask = ({ scrollLeft, scrollWidth, clientWidth }: HorizontalScrollBox, size: number) => {
	const fadeStart = scrollLeft > 0;
	const fadeEnd = scrollLeft < scrollWidth - clientWidth - 1;
	if (!fadeStart && !fadeEnd) return "";

	const start = fadeStart ? `transparent, black ${size}px` : "black";
	const end = fadeEnd ? `black calc(100% - ${size}px), transparent` : "black";
	return `linear-gradient(to right, ${start}, ${end})`;
};

export default getHorizontalScrollMask;
